import { useRecoilValue } from "recoil";
import { permissionsSelector } from "../../../Login/selectors/permissionSelector";
import { PERMISSIONS } from "../../../PermissionsConstants";
import PaymentRemittanceTypeTable from "./view/PaymentRemittanceTypeTable"

interface Props {}

export const PaymentRemittanceType: React.FC<Props> = () => {
  const viewPermission =
    PERMISSIONS.permission_utilities_configureagreement_paymentremittancetype_view;
  const userPermissions = useRecoilValue(permissionsSelector);
  return (
    <>
      {userPermissions.includes(viewPermission) && (
        <PaymentRemittanceTypeTable />
      )}
    </>
  );
};

export default PaymentRemittanceType;
